import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    data: {
        parameters: {},
        rows: [],
        totals: {},
        page: 1,
        total: 1,
        loading: false,
        ids: ''
    },
    chart: {
        parameters: {},
        rows: [],
        totals: {},
        loading: false
    },
    collectionKeysIds: [
        'Publisher', 'Offer', 'Goal', 'Link',
        'Country', 'District', 'Area', 'City',
        'CreativeType', 'CreativeLinkId','CreativeContainerId', 'CreativeBannerId', 'CreativeLandingId', 'CreativePromoCodeId'
    ]
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.STATISTICS_SEARCH_START_LOADING:
            return {
                ...state,
                data: {
                    ...state.data,
                    loading: true
                }
            };

        case AppConstants.STATISTICS_SEARCH_SUCCESS:
            return {
                ...state,
                data: {
                    parameters: action.items.parameters,
                    rows: action.items.rows,
                    totals: action.items.totals,
                    page: action.items.page || action.items.parameters.page,
                    total: getTotalPages(action.items.total, action.items.parameters.count),
                    loading: false,
                    ids: _formIdsList(action.items.rows, action.items.parameters)
                }
            };

        case AppConstants.STATISTICS_SEARCH_FAIL:
            return {
                ...state,
                data: {
                    ...state.data,
                    loading: false
                }
            };

        case AppConstants.STATISTICS_SEARCH_CHART_START_LOADING:
            return {
                ...state,
                chart: {
                    ...state.chart,
                    loading: true
                }
            };

        case AppConstants.STATISTICS_SEARCH_CHART_SUCCESS:
            return {
                ...state,
                chart: {
                    parameters: action.items.parameters,
                    rows: action.items.rows,
                    totals: action.items.totals,
                    loading: false
                }
            };

        case AppConstants.STATISTICS_SEARCH_CHART_FAIL:
            return {
                ...state,
                chart: {
                    ...state.chart,
                    loading: false
                }
            };

        case AppConstants.STATISTICS_CHART_CLEAR:
            return {
                ...state,
                chart: {
                    ...initialState.chart
                }
            };

        default:
            return state;
    }
};

const _formIdsList = (list, parameters) => {
    if (initialState.collectionKeysIds.includes(parameters.group_by)) {
        return list.map(item => item.GroupBy).join(',');
    } else {
        return '';
    }
};
